<div class="thirdLevelNav fw-TertiaryNavigation fw-TertiaryNavigation-mobile" *ngIf="layout=='vertical'">
    <ul class="fw-TertiaryNavigation_List layouts level-1">
        <ng-container *ngFor="let thirdLevel of thirdNavLinks">
            <li [class.open]="selectedThirdPageId == thirdLevel.id">
                <span class="open"
                    *ngIf="thirdLevel.istitle=='true'; else noTitle">{{ thirdLevel.name | pershingTranslate}}</span>
                <ng-template #noTitle>
                    <a id="nav-{{thirdLevel.id}}" href="javascript:void(0);"
                        (click)="handleThirdLevelNavigation(thirdLevel)"
                        >{{ thirdLevel.name | pershingTranslate}}</a>
                </ng-template>
            </li>
        </ng-container>
    </ul>
</div>
<div class="fw-TertiaryNavigation fw-TertiaryNavigation-desktop nav-f2 nav-menu nav-f2-desktop"
    *ngIf="layout=='horizontal'">
    <ul class="fw-TertiaryNavigation_List layouts level-1">
        <ng-container *ngFor="let thirdLevel of thirdNavLinks">
            <li [class.selected]="selectedThirdPageId == thirdLevel.id">
                <a href="javascript:void(0);"
                    (click)="handleThirdLevelNavigation(thirdLevel)">{{ thirdLevel.name | pershingTranslate}}</a>
            </li>
        </ng-container>
    </ul>
</div>
